// import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/app/power',
      name: 'power',
      component: () => import('@/page/power.vue'),
      meta: {
        assign: true
      }
    }, {
      path: '/app/power2',
      name: 'power2',
      component: () => import('@/page/power2.vue'),
      meta: {
        assign: true
      }
    },
    {
      path: '/app/test',
      name: 'test',
      component: () => import('@/page/test.vue'),
    }
    ,
    {
      path: '/app/achievement',
      name: 'achievement',
      component: () => import('@/page/achievement.vue'),
    }
    ,
    {
      path: '/app/order_detail',
      name: 'order_detail',
      component: () => import('@/page/order_detail.vue'),
    },
    {
      path: '/app/unlockH5',
      name: 'unlockH5',
      component: () => import('@/page/unlockH5.vue'),
    }
  ],
  mode: 'history'
})

router.afterEach((to, from) => {
  {
    if (to.query.app_id) {
      localStorage.setItem("app_id", to.query.app_id);
    }
    if (to.query.app_type) {
      localStorage.setItem("app_type", to.query.app_type);
    }
    if (to.query.bundle_id) {
      localStorage.setItem("bundle_id", to.query.bundle_id);
    }
  }
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    location.assign(targetPath)
  }
});
router.beforeEach((to, from, next) => {
  let wxios = is_ios();
  if ((to.path !== location.pathname) && wxios && to.meta.assign) {
    location.assign(to.fullPath)
  } else {
    next();
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js